module.exports = __webpack_public_path__ + "img/home-attending.99e41bd8.svg";